import { IBookingCalendarStore } from '../index'
import { ISetScrollTop } from '../../../actions/bookingCalendar/calendar/setScrollTop'

export default function(
  store: IBookingCalendarStore,
  action: ISetScrollTop,
): IBookingCalendarStore {
  return {
    ...store,
    scrollTop:
      action.scrollTop !== undefined ? action.scrollTop : store.scrollTop,
  }
}
